import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CollaboratorService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	loadCollaborator(payload) {
		return this._http.get(this.baseUrl + '/projects/');
	}
	// GET /collaborators/{organizationId } /compliance/export

	exportCompliance(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/compliance/export/`);
	}

	getCompliance(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/compliance/`, {
			params: payload.params
		});
	}

	dashboard(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/dashboard/`);
	}

	dashboardSubmitted(payload) {
		return this._http.get(
			`${this.baseUrl}/collaborators/${payload.organizationId}/complaints_submitted_dashboard/`
		);
	}

	dashboardExpiring(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/complaints_expiring_dashboard/`);
	}
}
